import React from "react";
import { Box, Skeleton } from "@mui/material";
import { COLORS, CONTENT_MAX_WIDTH } from "../shared/styles";

function CannedCardSkeleton() {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        minHeight: 176,
        p: "16px",
        borderRadius: "8px",
        border: `1px solid ${COLORS.borderLight}`,
        bgcolor: COLORS.white,
        boxSizing: "border-box",
      }}
    >
      <Skeleton width="40%" height={22} />
      <Skeleton width="30%" height={18} sx={{ mt: 1 }} />
      <Skeleton variant="rounded" height={56} sx={{ mt: 1.5, borderRadius: "8px" }} />
      <Skeleton width="35%" height={18} sx={{ mt: 1.5 }} />
    </Box>
  );
}

export default CannedCardSkeleton;
